<template>
  <main id="mainContent">
    <!-- <div> -->
        <NotificationStatus :show-message="displayNotification" />
 
      <div class="app-main-content">
        <p class="printShow">
          {{  this.message }}
        </p>
      <div class="app-content-panels">
        <div class="app-panel-left">
          <BaseButtonGroup>
            <button type="button" @click="handleRouting('info')">Resend confirmation</button>
            <button type="button" class="app-btn-primary" @click="handleRouting('print')">Print confirmation and receipt</button>
          </BaseButtonGroup>

          <ServiceInfo :show-barcode="false" />
          <PaymentReceipt />

          <BaseButtonGroup>
            <button class="button-home" type="button" @click="handleRouting('home')">
              Back to customer profile page
            </button>
          </BaseButtonGroup>
        </div>
        <AsideForUser />
      </div>

      <ModalContact :show-modal="showContactForm" @doClose="showContactForm = false"
                    @doNotificationMessage="handleModalNotification" />

    </div>
  </main>
</template>


<script>
// import _ from 'underscore'
import { mapState, mapActions, mapGetters } from 'vuex'
import ServiceInfo from '../../components/confirmation/ServiceInfo.vue';
import PaymentReceipt from '../../components/confirmation/PaymentReceipt.vue';
import BaseButtonGroup from '../../components/ui/BaseButtonGroup.vue';
import AsideForUser from '../../components/confirmation/AsideForUser.vue';
import ModalContact from '../../components/confirmation/ModalContact.vue';
import NotificationStatus from '../../components/confirmation/NotificationStatus.vue';
import * as COMMONS from '../../store/_commons'
import appConfig from '@/app.config'


export default {
  page: {
    title: `Transactions receipt| ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'Print or save your transaction(s) receipt'
      }
    ]
  },
  name: "Confirmation",
  props: {
    showMessage: {
      type: Boolean,
      required: false,
      default: false,     // prevent display on reload
    },
  },
  data() {
    return {
      feedback: {},
      screenData: {},
      showContactForm: false,
      displayNotification: true,
      modalCaller: 'getContact', // must match ref value for button in json
      inWorkTxnMessage:[],
      message:''
    };
  },
  components: {
    ServiceInfo,
    PaymentReceipt,
    BaseButtonGroup,
    AsideForUser,
    ModalContact,
    NotificationStatus
},
  computed: {
    ...mapState([
      'LANG',
      'STEPS'
    ]),

    ...mapGetters({
      // personalInfo: COMMONS.GUEST_PERSONAL_INFO,
      registrationInfo: COMMONS.GUEST_REGISTRATION_INFO,
      adjudicationLicenseInfo: COMMONS.GUEST_ADJUDICATION_LICENSE_INFO,
      adjudicationCommercialLicenseInfo: COMMONS.GUEST_ADJUDICATION_COMMERCIAL_LICENSE_INFO,
      adjudicationRegistrationInfo: COMMONS.GUEST_ADJUDICATION_REGISTRATION_INFO,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from;      // prevent NotificationStatus from display if user reloads browser
    });
  },

  watch: {
    showContactForm() {
      if (!this.showContactForm) {
        // note: for some reason Vue btn ref would not come thru here...
        const caller = document.getElementById(this.modalCaller);
        if (caller) {
          caller.focus();
        }
      }
    }
  },

  created() {
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
  },
  methods: {

    ...mapActions([
    ]),

    handleModalNotification(value) {
      this.displayNotification = true;
      this.$store.state.guestLogin.resNotificationSent = value;
    },

    handleRouting(target) {
      // index refers to the 'buttons' array elements in _steps.js
      switch (target) {
        case 'info':
          this.getContactInfo();
          break;
        case 'print':
          this.printConfirmation();
          break;
        case 'home':
          // this.cartTransactions = null
          this.$store.state.guestLogin.step = 1;
          this.$store.state.guestLogin.renewalCart = [];
          this.registrationInfo.registrationInformation = null;
          this.adjudicationLicenseInfo.adjudicationLicenseInformation = null; 
          this.adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation = null; 
          this.adjudicationRegistrationInfo.adjudicationRegistrationInformation = null;
          this.$store.state.guestLogin.cartTransactions = null;
          this.$store.state.guestLogin.resNotificationSent = null;
          this.$store.state.guestLogin.finalizationCart = null;
          this.$store.state.guestLogin.totalBill = null;
          this.$router.push({ name: 'Profile' });
          break;
        default:
          // nada
      }
    },

    goToProfile() {
      this.$router.push({name: 'Profile'});
    },

    getContactInfo() {
      this.displayNotification = false;
      // TODO: temp band-aid to "reset" showModal props in BaseModal to work with Esc key press
      this.showContactForm = false;
      this.$nextTick(() => {
        this.showContactForm = true;
      })
    },
    printConfirmation() {
      window.print();
    },
   
    checkInWorkTxns()
    {
      for(let i in this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions) {
                 if( this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions[i].transactionData.transactionStatus == "In Work")
                 {  
                  this.inWorkTxnMessage.push(this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions[i].transactionData.transactionId)
                 }
               }
               if(this.inWorkTxnMessage.length!==0)
               {
                this.message="Following Transaction(s) have failed. Transaction ID: " + this.inWorkTxnMessage.join(",",this.inWorkTxnMessage) + ". For more information, please contact the DMV at 401-462-4368. For transaction(s) completed successfully a confirmation text and / or e-mail has been sent to the information provided."
                        ;
               }
               else
               {
                this.message="Following RI DMV Online Customer Account transaction(s) have completed successfully. Below are the transaction and payment details."

              }

  },

    },

  mounted() {
    window.scroll(0,0);
    this.screenData = this.STEPS[this.stepNum]; 
    document.getElementById("mainContent").focus();
    this.checkInWorkTxns();
  }
}

</script>


<style lang="scss" scoped>
  .app-panel-left::v-deep .button-group {
    padding-bottom: calc(var(--padding-vertical) * .75);
  }
  .printShow{
    display: none;
  }
  @media print{
    .printShow {
      display: block; 
    }
  }
</style>